<template>
  <span>
    <el-button v-if="hasCycle(value) || record.exceptionCode || record.exceptionMessage" type="text" size="mini" class="period-value" @click="open">{{ text }}</el-button><span v-else>—</span>
    <period-detail v-if="visible" :visible.sync="visible" :record="selected" :type="type" current />
  </span>
</template>
<script>
import { periodText, hasCycle, pageRequest, errorText, responseData } from '../model'
import PeriodDetail from './PeriodDetail'
export default {
  components: { PeriodDetail },
  props: { type: { type: String, default: 'sku' }, code: [String, Number], value: [String, Number], record: { type: Object, default: () => ({}) } },
  data () { return { visible: false, selected: null, loading: false } },
  computed: { text () { return this.record.exceptionCode === 'NOT_SHELF' ? '不计算' : periodText(this.value) } },
  methods: {
    hasCycle,
    async open () {
      if (this.loading) return
      this.loading = true
      try {
        this.selected = { ...this.record, deliveryCycle: this.value }
        if (this.type === 'sku') { this.selected.skuCode = this.code; this.selected.skuName = this.record.skuName || this.record.goodsName }
        if (this.type === 'product') this.selected.productCode = this.code
        if (this.type === 'package') {
          const version = responseData(await this.$q.shippingPeriod.versions())
          if (!version || !version.latestTimeVersion) throw new Error('暂无可用的计算版本')
          const page = responseData(await this.$q.shippingPeriod.packages({ data: pageRequest(1, 30, { dataDate: version.dataDate, timeVersion: version.latestTimeVersion, packCode: this.code }) }))
          const row = (page.records || []).find(item => item.packCode === this.code)
          if (!row) throw new Error('暂无当前版本包件数据')
          this.selected = {
            ...row,
            dataDate: version.dataDate,
            timeVersion: version.latestTimeVersion,
            versionNo: row.versionNo || page.versionNo
          }
        }
        this.visible = true
      } catch (error) { this.$message.error(errorText(error)) } finally { this.loading = false }
    }
  }
}
</script>
<style scoped>.period-value{color:#13aa8d}</style>
